export default "__VITE_ASSET__VAdKRxAo__"